import './index.css';
import 'react-activity/dist/Dots.css';
import { useDispatch, useSelector } from 'react-redux';
import { useLink } from 'react-router-stack';
import { Header, ScreenBackground, Text, View, Card, RouteWrapper } from '../../../component';
import I18n from '../../../utilities/locale';
import useTheme from '../../../utilities/hooks/theme';
import { useEffect, useState } from 'react';
import moment from 'moment';
import {
  getRevenueAnalyticsAffiliate,
  getRevenueAnalyticsReferral,
  getUserAnalyticsAffiliate,
  getUserAnalyticsReferral
} from '../../../actions/user-actions-types';
import Button from '@mui/material/Button/Button';
import { Dots } from 'react-activity';
import { RoundedOffAmount } from '../../../utilities/helper';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import TextField from '@mui/material/TextField/TextField';

interface Props {
  title: any;
  value: any;
  style: any;
  theme: any;
}
const RevenueAnalyticsItem = ({ theme, title, value, style = {} }: Props) => {
  const cardBG = {
    backgroundColor: theme.revenueAnalyticsCardBG
  };
  const cardTitle = {
    color: theme.revenueAnalyticsCardTitle
  };
  return (
    <Card style={{ ...cardBG, ...style }} className={'revenue-analytics-item-container'}>
      <Text style={cardTitle} className={'revenue-analytics-item-title'}>
        {title}
      </Text>
      <Text style={cardTitle} className={'revenue-analytics-item-value'}>
        {value}
      </Text>
    </Card>
  );
};

const RevenueAnalytics = () => {
  const dispatch = useDispatch();
  const navigate = useLink();
  const { MoreTheme: theme } = useTheme();
  const user = useSelector((state: any) => state.user);
  const { affiliateId = '', referralId = '' } = user;
  const [startDate, setStartDate] = useState(moment(new Date()).format('YYYY-MM-DD') as any);
  const [startDateError, setStartDateError] = useState(null as any);
  const [endDate, setEndDate] = useState(moment(new Date()).format('YYYY-MM-DD') as any);
  const [endDateError, setEndDateError] = useState(null as any);
  const [loading, setLoading] = useState(false);
  const [totalTeams, setTotalTeams] = useState(0);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [deposit, setDeposit] = useState(0);
  const [registration, setRegistration] = useState(0);

  useEffect(() => {
    onPressGetDetails();
  }, []);

  const callRevenueAnalyticsReferralAPI = (referralId: any) => {
    setLoading(true);
    dispatch(
      getRevenueAnalyticsReferral({
        data: { referralId, startDate, endDate },
        callback: ({ result, error }: { result: any; error: any }) => {
          setLoading(false);
          if (!error && result) {
            setTotalTeams(
              result.fantasyCricket.team +
                result.fantasyKabaddi.team +
                result.fantasySubstitute.team
            );
            setTotalRevenue(
              result.fantasyCricket.revenue +
                result.fantasyKabaddi.revenue +
                result.fantasySubstitute.revenue
            );
          }
        }
      })
    );
  };

  const callRevenueAnalyticsAffiliateAPI = (affiliateId = '') => {
    setLoading(true);
    dispatch(
      getRevenueAnalyticsAffiliate({
        data: { affiliateId, startDate, endDate },
        callback: ({ result, error }: { result: any; error: any }) => {
          setLoading(false);
          if (!error && result) {
            setTotalTeams(
              result.fantasyCricket.team +
                result.fantasyKabaddi.team +
                result.fantasySubstitute.team
            );
            setTotalRevenue(
              result.fantasyCricket.revenue +
                result.fantasyKabaddi.revenue +
                result.fantasySubstitute.revenue
            );
          }
        }
      })
    );
  };

  const callUserAnalyticsReferralAPI = (referralId: any) => {
    setLoading(true);
    dispatch(
      getUserAnalyticsReferral({
        data: { referralId, startDate, endDate },
        callback: ({ result, error }: { result: any; error: any }) => {
          setLoading(false);
          if (!error && result) {
            const { deposit = 0, registrations = 0 } = result;
            setDeposit(deposit);
            setRegistration(registrations);
          }
        }
      })
    );
  };

  const callUserAnalyticsAffiliateAPI = (affiliateId = '') => {
    setLoading(true);
    dispatch(
      getUserAnalyticsAffiliate({
        data: { affiliateId, startDate, endDate },
        callback: ({ result, error }: { result: any; error: any }) => {
          setLoading(false);
          if (!error && result) {
            const { deposit = 0, registrations = 0 } = result;
            setDeposit(deposit);
            setRegistration(registrations);
          }
        }
      })
    );
  };

  const handleStartDatePicked = (date: any) => {
    setStartDate(moment(new Date(date)).format('YYYY-MM-DD'));
    if (startDateError != null) setStartDateError(null);
  };

  const handleEndDatePicked = (date: any) => {
    setEndDate(moment(new Date(date)).format('YYYY-MM-DD'));
    if (endDateError != null) setEndDateError(null);
  };

  const onPressGetDetails = () => {
    if (affiliateId) {
      callRevenueAnalyticsAffiliateAPI(affiliateId);
      callUserAnalyticsAffiliateAPI(affiliateId);
    } else {
      callRevenueAnalyticsReferralAPI(referralId);
      callUserAnalyticsReferralAPI(referralId);
    }
  };

  const validateDate = (date: any) => {
    var date_regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
    return date_regex.test(date);
  };

  const onPressSubmit = () => {
    if (!validateDate(startDate)) {
      setStartDateError('Enter Valid Start Date (YYYY-MM-DD)');
      return true;
    }
    if (!validateDate(endDate)) {
      setStartDateError('Enter Valid End Date (YYYY-MM-DD)');
      return true;
    }
    onPressGetDetails();
  };

  const onClickBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const btn = {
    color: theme.revenueAnalyticsBtnLabel,
    backgroundColor: theme.revenueAnalyticsBtnBG
  };

  const submitBtn = {
    color: theme.revenueAnalyticsSubmitBtnLabel,
    backgroundColor: theme.revenueAnalyticsSubmitBtnBG
  };

  const spinnerTitle = {
    color: theme.revenueAnalyticsSpinner
  };

  const inputSx: SxProps<Theme> = {
    '& .MuiInputBase-input': {
      color: theme.revenueAnalyticsBtnLabel,
      fontSize: '1.1rem',
      fontFamily: 'ProximaNova-Regular',
      textTransform: 'uppercase',
      textAlign: 'center'
    },
    '& .MuiFormHelperText-root.Mui-error': {
      backgroundColor: theme.revenueAnalyticsBtnBG,
      margin: 0,
      color: theme.error,
      paddingLeft: '5px',
      fontSize: '1.1rem',
      fontFamily: 'ProximaNova-Regular',
      textTransform: 'none'
    },
    '& .MuiInputLabel-root': {
      color: theme.revenueAnalyticsBtnLabel,
      fontSize: '1.1rem',
      fontFamily: 'ProximaNova-Regular',
      textTransform: 'none'
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: theme.editProfileTextInputColor,
      fontSize: '1.1rem',
      fontFamily: 'ProximaNova-Regular',
      textTransform: 'none'
    },
    '& input::placeholder': {
      color: theme.revenueAnalyticsBtnLabel,
      fontSize: '1.1rem',
      textTransform: 'none'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: theme.revenueAnalyticsBtnLabel,
        borderWidth: '0px'
      },
      '&:hover fieldset': {
        borderColor: theme.revenueAnalyticsBtnLabel,
        borderWidth: '0px'
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.revenueAnalyticsBtnLabel,
        borderWidth: '0px'
      }
    }
  };
  return (
    <RouteWrapper>
      <ScreenBackground>
        <Header title={I18n.t('RevenueAnalytics')} onClickBack={onClickBack} />
        <View className={'revenue-analytics-container'}>
          <View className={'revenue-analytics-date-container'}>
            <View>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <MobileDatePicker
                  inputFormat="yyyy-MM-dd"
                  value={startDate}
                  onChange={handleStartDatePicked}
                  maxDate={new Date()}
                  renderInput={(params: any) => (
                    <TextField
                      className={'revenue-analytic-text-input '}
                      placeholder={'Start Date'}
                      style={btn}
                      size="small"
                      sx={inputSx}
                      error={startDateError ? true : false}
                      helperText={startDateError}
                      {...params}
                    />
                  )}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <MobileDatePicker
                  inputFormat="yyyy-MM-dd"
                  value={endDate}
                  onChange={handleEndDatePicked}
                  maxDate={new Date()}
                  renderInput={(params: any) => (
                    <TextField
                      className={'revenue-analytic-text-input '}
                      placeholder={'End Date'}
                      style={btn}
                      size="small"
                      sx={inputSx}
                      error={endDateError ? true : false}
                      helperText={endDateError}
                      {...params}
                    />
                  )}
                />
              </LocalizationProvider>
            </View>
            <View>
              <Button
                style={submitBtn}
                onClick={onPressSubmit}
                className={'revenue-analytics-date-btn '}>
                {'Get Details'}
              </Button>
            </View>
          </View>
          {loading ? (
            <View className={'revenue-analytics-spinner-container'}>
              <Dots color={theme.revenueAnalyticsSpinner} size={25} />
              <Text style={spinnerTitle} className={'revenue-analytics-spinner-title'}>
                {'Loading Data'}
              </Text>
            </View>
          ) : (
            <>
              <View className={'revenue-analytics-wrapper'}>
                <RevenueAnalyticsItem
                  title={'*Teams Played'}
                  value={`${totalTeams}`}
                  theme={theme}
                  style={{}}
                />
                <RevenueAnalyticsItem
                  title={'Total Revenue'}
                  value={`₹${RoundedOffAmount(totalRevenue)}/-`}
                  style={{
                    marginLeft: '8px'
                  }}
                  theme={theme}
                />
              </View>
              <View className={'revenue-analytics-wrapper'}>
                <RevenueAnalyticsItem
                  title={'Deposit By Users'}
                  value={`₹${RoundedOffAmount(deposit)}/-`}
                  theme={theme}
                  style={{}}
                />
                <RevenueAnalyticsItem
                  title={'Registrations'}
                  value={`${registration}`}
                  style={{
                    marginLeft: '8px'
                  }}
                  theme={theme}
                />
              </View>
            </>
          )}
          <Text style={spinnerTitle} className={'revenue-analytics-disclaimer'}>
            {'Disclaimer - "Teams Played" data available only after 3rd Feb 2022'}
          </Text>
        </View>
      </ScreenBackground>
    </RouteWrapper>
  );
};
export default RevenueAnalytics;
